module.exports = __webpack_public_path__ + "img/kpxjt_right_select.d0344f26.png";